import { memo, type ReactNode } from 'react';

import { PendingOnboardingUploadFilesProvider } from '~/components/WorkspaceOnboardingForm/PendingOnboardingUploadFilesProvider';

export type PendingOnboardingUploadFilesLayoutProps = {
  children: ReactNode;
};

const PendingOnboardingUploadFilesLayout = memo(({ children }: PendingOnboardingUploadFilesLayoutProps) => {
  return <PendingOnboardingUploadFilesProvider>{children}</PendingOnboardingUploadFilesProvider>;
});

PendingOnboardingUploadFilesLayout.displayName = 'PendingOnboardingUploadFilesLayout';

export const getPendingOnboardingUploadFilesLayout = (page: ReactNode) => (
  <PendingOnboardingUploadFilesLayout>{page}</PendingOnboardingUploadFilesLayout>
);
